var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.file)?_c('div',{staticClass:"wrapper",on:{"click":_vm.redirectToFile}},[_c('AzIcon',{attrs:{"icon-name":"file-pdf","size":"largest"}}),_vm._v(" "),(_vm.file.fields)?_c('p',{staticClass:"wrapper__title"},[_vm._v(_vm._s(_vm.file.fields.title))]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }